import { useState } from 'react';

export default function Purchase() {
  const [selectedOption, setSelectedOption] = useState('30pack');
  const [quantity, setQuantity] = useState(1);

  const options = [
    { id: '30pack', name: '30팩 (100mL × 30)', price: 45000, unit: 1500 },
    { id: '50pack', name: '50팩 (100mL × 50)', price: 72000, unit: 1440, badge: '인기' },
    { id: '60pack', name: '60팩 (100mL × 60)', price: 84000, unit: 1400, badge: '최저가' }
  ];

  const selectedProduct = options.find(opt => opt.id === selectedOption);
  const totalPrice = selectedProduct ? selectedProduct.price * quantity : 0;

  return (
    <section id="purchase-section" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            구매하기
          </h2>
          <p className="text-lg text-gray-600">
            신선한 포도즙을 지금 바로 만나보세요.
          </p>
        </div>

        <div className="bg-[#FDFBF7] rounded-2xl p-8 border-2 border-gray-200">
          {/* 옵션 선택 */}
          <div className="mb-8">
            <h3 className="text-xl font-bold text-gray-900 mb-4">구성 선택</h3>
            <div className="space-y-3">
              {options.map((option) => (
                <div
                  key={option.id}
                  onClick={() => setSelectedOption(option.id)}
                  className={`relative p-6 rounded-xl border-2 cursor-pointer transition-all ${
                    selectedOption === option.id
                      ? 'border-[#6B4E9C] bg-[#6B4E9C]/5'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                >
                  {option.badge && (
                    <div className="absolute -top-3 left-6 bg-[#6B4E9C] text-white px-3 py-1 rounded-full text-sm font-bold whitespace-nowrap">
                      {option.badge}
                    </div>
                  )}
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4">
                      <div className={`w-6 h-6 flex items-center justify-center rounded-full border-2 ${
                        selectedOption === option.id
                          ? 'border-[#6B4E9C] bg-[#6B4E9C]'
                          : 'border-gray-300'
                      }`}>
                        {selectedOption === option.id && (
                          <i className="ri-check-line text-white text-sm"></i>
                        )}
                      </div>
                      <div>
                        <p className="font-bold text-gray-900">{option.name}</p>
                        <p className="text-sm text-gray-600">팩당 {option.unit.toLocaleString()}원</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-2xl font-bold text-[#6B4E9C]">
                        {option.price.toLocaleString()}원
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 수량 선택 */}
          <div className="mb-8">
            <h3 className="text-xl font-bold text-gray-900 mb-4">수량</h3>
            <div className="flex items-center gap-4">
              <button
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                className="w-12 h-12 flex items-center justify-center bg-white border-2 border-gray-300 rounded-lg hover:border-[#6B4E9C] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-subtract-line text-xl"></i>
              </button>
              <input
                type="number"
                value={quantity}
                onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
                className="w-24 h-12 text-center text-xl font-bold border-2 border-gray-300 rounded-lg focus:border-[#6B4E9C] focus:outline-none"
              />
              <button
                onClick={() => setQuantity(quantity + 1)}
                className="w-12 h-12 flex items-center justify-center bg-white border-2 border-gray-300 rounded-lg hover:border-[#6B4E9C] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-add-line text-xl"></i>
              </button>
            </div>
          </div>

          {/* 총 금액 */}
          <div className="bg-white rounded-xl p-6 mb-8 border border-gray-200">
            <div className="flex justify-between items-center mb-4">
              <span className="text-lg text-gray-700">상품 금액</span>
              <span className="text-xl font-bold text-gray-900">{totalPrice.toLocaleString()}원</span>
            </div>
            <div className="flex justify-between items-center mb-4 pb-4 border-b border-gray-200">
              <span className="text-lg text-gray-700">배송비</span>
              <span className="text-xl font-bold text-gray-900">무료</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-xl font-bold text-gray-900">총 결제 금액</span>
              <span className="text-3xl font-bold text-[#6B4E9C]">{totalPrice.toLocaleString()}원</span>
            </div>
          </div>

          {/* 구매 버튼 */}
          <button className="w-full bg-[#6B4E9C] text-white py-5 rounded-xl font-bold text-xl hover:bg-[#5A3D8B] transition-colors cursor-pointer whitespace-nowrap">
            구매하기
          </button>

          {/* 배송 및 환불 정보 */}
          <div className="mt-8 space-y-4 text-sm text-gray-600">
            <div className="flex items-start gap-2">
              <i className="ri-truck-line text-[#6B4E9C] mt-1 flex-shrink-0"></i>
              <div>
                <strong className="text-gray-900">배송:</strong> 주문 후 2~3일 이내 출고 (영업일 기준), 제주/도서산간 지역 추가 배송일 소요
              </div>
            </div>
            <div className="flex items-start gap-2">
              <i className="ri-refresh-line text-[#6B4E9C] mt-1 flex-shrink-0"></i>
              <div>
                <strong className="text-gray-900">교환/환불:</strong> 수령 후 7일 이내 가능 (단, 제품 개봉 시 교환/환불 불가)
              </div>
            </div>
            <div className="flex items-start gap-2">
              <i className="ri-gift-line text-[#6B4E9C] mt-1 flex-shrink-0"></i>
              <div>
                <strong className="text-gray-900">재구매 혜택:</strong> 2회 이상 구매 시 5% 할인 쿠폰 자동 발급
              </div>
            </div>
          </div>
        </div>

        {/* 신뢰 배지 */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          <div className="flex flex-col items-center gap-2">
            <div className="w-16 h-16 flex items-center justify-center bg-[#6B4E9C]/10 rounded-full">
              <i className="ri-shield-check-line text-3xl text-[#6B4E9C]"></i>
            </div>
            <p className="text-sm font-semibold text-gray-700">안전한 결제</p>
          </div>
          <div className="flex flex-col items-center gap-2">
            <div className="w-16 h-16 flex items-center justify-center bg-[#6B4E9C]/10 rounded-full">
              <i className="ri-truck-line text-3xl text-[#6B4E9C]"></i>
            </div>
            <p className="text-sm font-semibold text-gray-700">무료 배송</p>
          </div>
          <div className="flex flex-col items-center gap-2">
            <div className="w-16 h-16 flex items-center justify-center bg-[#6B4E9C]/10 rounded-full">
              <i className="ri-customer-service-2-line text-3xl text-[#6B4E9C]"></i>
            </div>
            <p className="text-sm font-semibold text-gray-700">고객 지원</p>
          </div>
          <div className="flex flex-col items-center gap-2">
            <div className="w-16 h-16 flex items-center justify-center bg-[#6B4E9C]/10 rounded-full">
              <i className="ri-refresh-line text-3xl text-[#6B4E9C]"></i>
            </div>
            <p className="text-sm font-semibold text-gray-700">간편 환불</p>
          </div>
        </div>
      </div>
    </section>
  );
}